import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const certificateGroupingApi = createApi({
    reducerPath: 'certificateGroupingApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getProductDetailsListByProductInformationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetProductDetailsListByProductInformationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        costAlloctionBySGBPProducatInformationId: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/CostAlloctionBySGBPProducatInformationId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendCertificateGroupingRequestForReview: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SendCertificateGroupingRequestForReview',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllBatchCertificatesList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GetAllBatchCertificatesList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        validateCertificateNumberForAssignment: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/ValidateCertificateNumberForAssignment',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateApplicationStatusOnPeerReviewerReturn: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/UpdateApplicationStatusOnPeerReviewerReturn',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveSGBPSApplicationByFinalApprover: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/ApproveSGBPSApplicationByFinalApprover',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveSelfEvaluationFinalApproverDetails: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveSelfEvaluationFinalApproverDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCertificateAndCostAllocationList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateAndCostAllocationList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsForCommonById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsForCommonById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveFinalCertificateAndCostAllocation: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveFinalCertificateAndCostAllocation',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCertificateAndCostAllocationListForGWPGeneral: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateAndCostAllocationListForGWPGeneral',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsForGWPGeneralById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsForGWPGeneralById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCertificateIssuanceDetailsTaskList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateIssuanceDetailsTaskList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBPSCertificateIssuanceList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GetSGBPSCertificateIssuanceList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        generateCertificateForIssuance: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GenerateCertificateForIssuance',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getGWPConcreteTemplate: builder.query({
            query: (details) => ({
                url: `/CaseOfficerAndPeerReviewer/GetGWPConcreteTemplate?type=${details.type}&fileName=${details.fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSucessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),
        saveCertificateAndCostAllocationListForTVOC: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateAndCostAllocationListForTVOC',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsForTVOCById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsForTVOCById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveBatchCertificateInvoice: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/SaveBatchCertificateInvoice',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        invoiceApprovalTaskList: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/InvoiceApprovalTaskList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateInvoiceApprovalStatus: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/UpdateInvoiceApprovalStatus',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        createCertificationInvoice: builder.mutation({
            query: (details) => ({
                url: '/ProductAndServiceXero/CreateCertificationInvoice',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        checkManualInvoiceNumber: builder.mutation({
            query: (details) => ({
                url: '/ProductAndServiceXero/CheckManualInvoiceNumber',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsForWithoutRatingById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsForWithoutRatingById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCertificateAndCostAllocationListForWithoutRating: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateAndCostAllocationListForWithoutRating',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsForWithRatingById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsForWithRatingById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCertificateAndCostAllocationListForWithRating: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateAndCostAllocationListForWithRating',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBPSApplicationAuditLogList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GetSGBPSApplicationAuditLogList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getUpdatedByDropdownForAuditLog: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetUpdatedByDropdownForAuditLog?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        checkManualInvoiceNumber: builder.mutation({
            query: (details) => ({
                url: '/ProductAndServiceXero/CheckManualInvoiceNumber',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBPSApplicationAuditLogList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GetSGBPSApplicationAuditLogList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getUpdatedByDropdownForAuditLog: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetUpdatedByDropdownForAuditLog?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyGetProductDetailsListByProductInformationIdQuery,
    useLazyGetCertificateGroupingDetailsByIdQuery,
    useCostAlloctionBySGBPProducatInformationIdMutation,
    useSendCertificateGroupingRequestForReviewMutation,
    useGetAllBatchCertificatesListMutation,
    useValidateCertificateNumberForAssignmentMutation,
    useUpdateApplicationStatusOnPeerReviewerReturnMutation,
    useApproveSGBPSApplicationByFinalApproverMutation,
    useSaveSelfEvaluationFinalApproverDetailsMutation,
    useSaveCertificateAndCostAllocationListMutation,
    useLazyGetCertificateGroupingDetailsForCommonByIdQuery,
    useSaveFinalCertificateAndCostAllocationMutation,
    useSaveCertificateAndCostAllocationListForGWPGeneralMutation,
    useLazyGetCertificateGroupingDetailsForGWPGeneralByIdQuery,
    useSaveCertificateIssuanceDetailsTaskListMutation,
    useGetSGBPSCertificateIssuanceListMutation,
    useGenerateCertificateForIssuanceMutation,
    useLazyGetGWPConcreteTemplateQuery,
    useSaveCertificateAndCostAllocationListForTVOCMutation,
    useLazyGetCertificateGroupingDetailsForTVOCByIdQuery,
    useSaveBatchCertificateInvoiceMutation,
    useInvoiceApprovalTaskListMutation,
    useUpdateInvoiceApprovalStatusMutation,
    useCreateCertificationInvoiceMutation,
    useLazyGetCertificateGroupingDetailsForWithoutRatingByIdQuery,
    useSaveCertificateAndCostAllocationListForWithoutRatingMutation,
    useLazyGetCertificateGroupingDetailsForWithRatingByIdQuery,
    useSaveCertificateAndCostAllocationListForWithRatingMutation,
    useCheckManualInvoiceNumberMutation,
    useGetSGBPSApplicationAuditLogListMutation,
    useLazyGetUpdatedByDropdownForAuditLogQuery
} = certificateGroupingApi;

export default certificateGroupingApi;